import { Component, OnInit, EventEmitter, DoCheck, ViewChild } from '@angular/core';
import { ClientUser } from '../../models/client-user';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { SessionService } from '../../session-service/session.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastrService } from '@kpmg-tax/ui';
import { Messages } from '../../../shared/constants/messages';
import { Output } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { emailEditorConfig } from '../../../shared/constants/email-editor-config';
import { EmailPopupData, TemplateRequest, ModifiedSMETemplates, SendEmailRequest, EmailCCList, CustomTemplateRequest, EmailDefaultCcDto, UseAsAutoReminderEmailDto, AssignSmeTemplateDto, CustomEmailTemplateDto } from '../../models/email';
import { EmailService } from './email.service';
import { SurveyCategory, SurveyScreenType, TemplateRequestType } from '../../constants/survey-status';
import { encodeText, decodeText } from 'src/app/shared/lib/custom-tools';
import { CustomDropDown } from '../../models/custom-dropdown.model';
import { CustomDropdownComponent } from '../../custom-dropdown/custom-dropdown.component';
import { role } from 'src/app/shared/constants/role-enum';
import { isRcnSurveyApplication } from 'src/app/shared/lib/custom-tools';
import { APP_CONSTANTS, EMAIL_INITIAL_ASSIGNMENT, EMAIL_LINK, EMAIL_TEMPLATE_TYPE } from '../../constants/app-constants';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { UserDetails } from 'src/app/core/models/user-details.model';
import { TooltipOptions } from 'ng2-tooltip-directive';
import { SurveyAssignedSMEsEmailSentDetails } from '../../models/SurveyDetails';
import { SmeUserDetail } from '../../models/get-all-users-response.model';
import { ManageClientUsersService } from 'src/app/manage-study/manage-client-users/manage-client-users.service';
import { ClientSmeUser } from '../../models/client-user-response.model';
@Component({
  selector: 'email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit, DoCheck {
  readonly DEFAULT_EMAIL_TEMPLATE: string = 'Default email template';
  targetForm: FormGroup;
  emailTemplate: FormControl;
  @Output() drawerWidth = new EventEmitter<any>();
  sendSmeList: ClientUser[] = [];
  selectedSmeId: number;
  emailSubject: string;
  defaultTemplate: string;
  defaultModifyTemplate: string;
  defaultEmailSubject: string;
  selectedSmeName: string;
  isDisableSendMailButton: boolean = false;
  isReminderEnabled: boolean = false;
  placeholders: string[] = [
    'SME',
    'SME_Full',
    'Client',
    'ClientManager',
    'Admin',
    'SurveyList',
    'ClientAdmin',
  ];
  dropdownSettings: IDropdownSettings = {};
  cCList: ClientUser[] = [];
  selectedcCList: ClientUser[] = [];
  editorConfig = emailEditorConfig;
  mentionConfig = { triggerChar: '#', mentionSelect: this.onMentionSelect };
  dropdownList: ClientUser[] = [];
  modifyDefaultTemplate: boolean = true;
  emailPopupData = new EmailPopupData();
  modifiedSMETemplates: ModifiedSMETemplates[] = [];
  emailContent: string;
  customTemplateTitle = this.DEFAULT_EMAIL_TEMPLATE;
  customTemplateTitleOptions: CustomDropDown[] = [];
  isDisableCustomTemplateButton: boolean = false;
  showSaveTemplateOption: boolean = false;
  showSaveButton: boolean = false;
  showDeleteButton: boolean = false;
  isAutoReminderTemplate: boolean = false;
  isDefaultAutoReminderTemplate: boolean = false;
  setAsDefaultEnabled: boolean = false;
  roleId: number;
  championRole: number = role.champion;
  adminRole: number = role.admin;
  showRefreshButton: boolean = true;
  isRcnSurveyApp: boolean = false;
  currentUserId: number;
  defaultTemplateToolTip: string = 'Default template for automated reminders';
  remindersDisabledToolTip: string = 'Automated reminders are disabled for this study. Go to "Edit Study" and Enable automated reminders';
  userDetails: UserDetails = {} as UserDetails;
  isKPMGUser = false;
  isEmailSentToAllSme: boolean = false;
  emailType: EMAIL_TEMPLATE_TYPE;
  tableGuidanceToolTip: string = EMAIL_INITIAL_ASSIGNMENT.GUIDANCE_TOOLTIP;
  linkGuidanceToolTip: string = EMAIL_LINK.LINK_GUIDANCE_TOOLTIP;
  myOptions:TooltipOptions = {
    'maxWidth': '350px'
  } as TooltipOptions;
  clientId:number;
  constructor(private _userDataService: UserDataService,
    public rightSideDrawerService: RightSideDrawerService,
    public sessionService: SessionService,
    public formBuilder: FormBuilder,
    public toastrService: ToastrService,
    public _emailService: EmailService,
    private manageClientUserService: ManageClientUsersService
  ) { }

  ngOnInit(): void {
    this.targetForm = this.formBuilder.group({
      subject: [{ value: '', disabled: false }, [Validators.required]],
      emailTemplate: ['', [Validators.maxLength(4000)]],
      templateName: [{ value: '', disabled: false }, [Validators.required]],
    });
    this.drawerWidth.emit("calc(81vw - 80px)");
    this.emailPopupData = this.rightSideDrawerService.singleRowAddData;
    this._userDataService.userDetails$.subscribe(user => {
      if (user) {
        this.userDetails = user;
        this.currentUserId = user.userId;
        this.roleId = user.roleId;
        this.isKPMGUser = this.userDetails.roleId === role.admin || this.userDetails.roleId === role.champion ? true : false;
      }
    });
    this.rightSideDrawerService.drawerOpen.subscribe(drawerData => {
      if (drawerData && drawerData.drawerTitle.toLowerCase() === APP_CONSTANTS.ASSIGNMENT_EMAIL.toLowerCase()) {
        this.emailType = EMAIL_TEMPLATE_TYPE.ASSIGNMENT_EMAIL;
      }
    });
    
    this.isRcnSurveyApp = isRcnSurveyApplication();
    this.getEmailTemplate();
  }
  ngDoCheck() {
    this.rightSideDrawerService.setMandatoryField(true, 'email');
  }

  getEmailTemplate() {
    this.rightSideDrawerService.spinnerLoad(true);
    const templateRequest = new TemplateRequest();    
    templateRequest.engagementId = this.emailPopupData.engagementId;
    templateRequest.SME = this.emailPopupData.SME;
    if (this.emailPopupData.requestTemplateType != TemplateRequestType.Reminder && this.emailPopupData.surveyScreenType != SurveyScreenType.Details) {
      templateRequest.SurveyId = this.emailPopupData.SurveyId;
    }
    templateRequest.surveyType = this.emailPopupData.surveyType;
    templateRequest.requestTemplateType = this.emailPopupData.requestTemplateType;
    templateRequest.sendToAll = this.emailPopupData.sendToAll;
    this._emailService.GetSMEEmailModifyTemplate(templateRequest).subscribe((data: AssignSmeTemplateDto) => {
      if (data) {
        data.subject = decodeText(data.subject);
        data.emailContent = decodeText(data.emailContent);
        this.targetForm.controls.subject.setValue(data.subject);
        this.emailSubject = data.subject
        this.defaultEmailSubject = data.subject;
        this.isReminderEnabled = data.isReminderEnabled;        
        this.targetForm.controls.emailTemplate.setValue(data.emailContent);
        data.emailContent = this.removeKeywordsFromTemplate(data.emailContent);
        this.emailContent = data.emailContent;
        this.defaultTemplate = data.emailContent;
        this.defaultModifyTemplate = data.emailContent;
        this.sendSmeList = this.emailPopupData.surveyScreenType === SurveyScreenType.Details ? this.emailPopupData.SMEList : data.smeList;        
        this.cCList = this.getCCList(data.ccList);        
        this.dropdownList = this.cCList;
        if (this.emailPopupData.requestTemplateType === TemplateRequestType.Default) {
            if (this.cCList.some(x => x.isDefaultSelected)) {
                this.selectedcCList = this.dropdownList.filter(x => x.isDefaultSelected);
            } else {
                this.selectedcCList = this.dropdownList;
            }
        } else {
            this.selectedcCList = this.dropdownList.filter(x => x.isDefaultSelected);
        }
        if (this.selectedcCList.length === 0) {
          this.selectedcCList = this.cCList.filter(x => x.userId === this.currentUserId);
          this.enableSetAsDefault();
        }        
        this.getDropDownList();
        this.dropdownSettings = {
          singleSelection: false,
          defaultOpen: false,
          idField: 'userId',
          textField: 'displayName',
          enableCheckAll: false,
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          allowSearchFilter: true,
        };
        this.isAutoReminderTemplate = data.customEmailTemplatesList.every(x => !x.isAutoReminderTemplate);
        this.isDefaultAutoReminderTemplate = this.isAutoReminderTemplate;
        this.customTemplateTitleOptions = this.getCustomTemplateOptions(data.customEmailTemplatesList);
        this.rightSideDrawerService.spinnerLoad(false);
      }
    });
  }

  getDropDownList(){          
    let adminSmeId: number[];
    let adminSme: ClientSmeUser[];
    this.cCList = [...this.cCList, ...this.getOptionalSme(this.emailPopupData.SMEOptional)]
    this.manageClientUserService.getClientSmeUsers(this.clientId, this.emailPopupData.engagementId).subscribe(
      response => { 
        adminSme = response.filter(r => r.userId > 0 && r.roleIds.includes(role.clientAdmin));                 
        adminSmeId = adminSme.map(({ userId }) => userId);
        let result = this.cCList.filter(r=> !adminSmeId.includes(r.userId));
        this.dropdownList = result;
      });            
  }

  getCCList(list:ClientUser[]): ClientUser[]{
    let ccList:ClientUser[] = [];    
    let listWithClientId = list.filter(t=> t.clientId !== null);
    this.clientId = listWithClientId.length > 0 ? listWithClientId[0].clientId : 0;
    list.forEach(element => {
      if(!this.sendSmeList.find(el => el.userId === element.userId)){
        let sme:ClientUser = {
          clientId:element.clientId,
          userId: element.userId,
          userName: element.userName,
          displayName: element.displayName,
          email: element.email,
          clientName: element.clientName,
          jobTitle: '',
          role: element.role,
          isDelete: element.isDelete,
          alias: '',
          isSelected: false,
          isDefaultSelected: element.isDefaultSelected
        };
        ccList.push(sme);
      }
    });        
    return ccList;
  }

  getOptionalSme(optionalSme: SmeUserDetail[]): ClientUser[]{
    let smeUserOptional:ClientUser[] = [];
    if(optionalSme?.length > 0)
    {
      optionalSme.forEach(element => {
        if(!this.cCList.find(el => el.userId === element.userId) && !this.sendSmeList.find(el => el.userId === element.userId)){
          let sme:ClientUser = {
            clientId:element.clientId,
            userId: element.userId,
            userName: element.userName,
            displayName: element.displayName,
            email: element.email,
            clientName: element.clientName,
            jobTitle: '',
            role: element.roleName,
            isDelete: element.isDelete,
            alias: '',
            isSelected: false,
            isDefaultSelected: false
          };
          smeUserOptional.push(sme);
        }      
      });
    }    
    return smeUserOptional;
  }  

  public setCcAsDefaultClick() {
    if (!this.setAsDefaultEnabled) return;
    this.rightSideDrawerService.spinnerLoad(true);
    let emailDefaultCcDto = {} as EmailDefaultCcDto;
    emailDefaultCcDto.engagementId = this.emailPopupData.engagementId;
    emailDefaultCcDto.userIds = this.selectedcCList
      ? [...new Set(this.selectedcCList.map(x => x.userId))]
      : [];
    this._emailService.updateEmailDefaultCc(emailDefaultCcDto).subscribe((result: boolean) => {
      this.rightSideDrawerService.spinnerLoad(false);
      if (result === true) {
        this.disableSetAsDefault();
        this.toastrService.setSuccessMessage(Messages.Survey.SaveEmailDefaultCCsOK);
      }
    });
  }

  private enableSetAsDefault() {
    this.setAsDefaultEnabled = true;
  }

  private disableSetAsDefault() {
    this.setAsDefaultEnabled = false;
  }

  onItemSelect(item: ClientUser) {
    if (!this.selectedcCList.some(x => x.userId == item.userId)) {
      this.selectedcCList.push(item);
    };
    this.enableSetAsDefault();
  }

  onItemDeSelect(item: ClientUser) {
    this.selectedcCList = this.selectedcCList.filter(x => x.userId !== item.userId);
    this.enableSetAsDefault();
  }

  inputSubjectChanged(event) {
    this.emailSubject = this.targetForm.get('subject').value;
  }
  inputEmailContentChanged(event) {
    this.emailContent = this.removeKeywordsFromTemplate(this.targetForm.get('emailTemplate').value);
  }
  updateModified(event) {
    if (this.selectedSmeId > 0) {
      let changedData = this.sendSmeList.find(x => x.userId === this.selectedSmeId);
      const template = this.modifiedSMETemplates.filter(x => x.smeId === changedData.userId);
      if (template.length > 0) {
        template[0].emailContent = this.emailContent;
      } else {
        const modififedTemplate = new ModifiedSMETemplates();
        modififedTemplate.smeId = changedData.userId;
        modififedTemplate.emailContent = this.emailContent;
        this.modifiedSMETemplates.push(modififedTemplate);
      }
    } else {
      this.defaultModifyTemplate = this.emailContent;
    }
  }
  trimSpecialChar(ctrl: any) {
    this.targetForm.controls[ctrl].setValue(
      this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-()._&/ ]/g, ''),
    );
  }
  sendEmailtoSelected(smeId) {
    const smeIds = [this.selectedSmeId];
    this.sendEmailToAllSme(smeIds, false);
  }
  sendEmail() {    
    const smeIds = this.sendSmeList.map(x => x.userId);
    this.sendEmailToAllSme(smeIds, true);
  }
  sendEmailToAllSme(smeIds, isEmailSentToAllSme) {
    this.rightSideDrawerService.spinnerLoad(true);
    const sendRequest = new SendEmailRequest();
    const ccLists = new Array<EmailCCList>();
    this.selectedcCList.forEach(element => {
      const ccList = new EmailCCList();
      ccList.userName = this.cCList.find(x => x.userId === element.userId).userName;
      ccList.userId = element.userId;
      ccList.displayName = element.displayName;
      ccLists.push(ccList);
    });
    sendRequest.engagementId = this.emailPopupData.engagementId;
    sendRequest.SmeIds = smeIds;
    sendRequest.deletedSmeIds = this.emailPopupData.deletedList;
    sendRequest.SurveyIds = this.emailPopupData.SurveyId;
    sendRequest.ccList = ccLists;
    sendRequest.surveyType = this.emailPopupData.surveyType;
    sendRequest.emailSubject = encodeText(this.targetForm.get('subject').value);
    sendRequest.emailContent = encodeText(this.emailContent);
    sendRequest.emailType = this.emailPopupData.requestTemplateType != TemplateRequestType.Reminder ? 'Default Email' : 'Reminder Email';
    sendRequest.surveyScreenType = this.emailPopupData.surveyScreenType;
    sendRequest.isEmailSentToAllSme = isEmailSentToAllSme;
    this.isEmailSentToAllSme = isEmailSentToAllSme;
    this._emailService.sendEmailToSme(sendRequest, this.emailPopupData.isWelcomeEmail).subscribe((data) => {
      this.isDisableSendMailButton = false;
      this.toastrService.setSuccessMessage(Messages.EMAIL_TO_SME);
      this.triggerDefaultEmailStatus();
      this.rightSideDrawerService.spinnerLoad(false);
    });
    }

    isAnySmeToSendEmail() {
        if (this.isEmailSentToAllSme) { return false; }
        else if (!this.isEmailSentToAllSme && this.sendSmeList.length > 1) return true;
        else return false;
    }

  triggerDefaultEmailStatus(){
    if(this.emailPopupData.requestTemplateType != TemplateRequestType.Reminder){
        let inputData:{engagementId:number, surveyIds:number[], anySmeTomail :boolean} = {
        engagementId : this.emailPopupData.engagementId,
            surveyIds: this.emailPopupData.SurveyId,
            anySmeTomail: this.isAnySmeToSendEmail()
      }
      this.rightSideDrawerService.closeRightSideDrawer({isDefaultEmailReminder:this.emailPopupData.surveyType, apiData:inputData });
    }
    else{
      this.rightSideDrawerService.closeRightSideDrawer();
    }
  }
  
  sendPreviewEmail(emailType: string): void {
    this.rightSideDrawerService.spinnerLoad(true);
    const sendRequest = new SendEmailRequest();
    sendRequest.engagementId = this.emailPopupData.engagementId;
    sendRequest.SmeIds = [this.selectedSmeId].length > 0 && [this.selectedSmeId][0] > 0? [this.selectedSmeId] : this.sendSmeList.map(x => x.userId);
    sendRequest.deletedSmeIds = this.emailPopupData.deletedList;
    sendRequest.SurveyIds = this.emailPopupData.SurveyId;
    sendRequest.surveyType = this.emailPopupData.surveyType;
    sendRequest.emailSubject = encodeText(this.targetForm.get('subject').value);
    sendRequest.emailContent = encodeText(this.emailContent);
    sendRequest.emailType = this.emailPopupData.requestTemplateType != TemplateRequestType.Reminder ? 'Default Email' : 'Reminder Email';
    sendRequest.surveyScreenType = this.emailPopupData.surveyScreenType;
    sendRequest.isPreviewEmail = true;
    this._emailService.sendEmailToSme(sendRequest, this.emailPopupData.isWelcomeEmail).subscribe((data) => {
      this.rightSideDrawerService.spinnerLoad(false);
      this.toastrService.setSuccessMessage(APP_CONSTANTS.PREVIEW_EMAIL_SUCCESS_MESSAGE);
    });
  }

  resetModifiedEmail() {
    if (this.customTemplateTitle === this.DEFAULT_EMAIL_TEMPLATE) {
      this.emailContent = this.removeKeywordsFromTemplate(this.defaultTemplate);
    } else {
      this.rightSideDrawerService.spinnerLoad(true);
      const templateid = this.customTemplateTitleOptions.filter(x => x.value === this.customTemplateTitle)[0].id;
      this.getCustomEmailTemplate(templateid);
    }
  }
  onMentionSelect(selection) {
    return '#' + selection.label + ' ';
  }
  updateSubject() {
    if (this.emailSubject === '') {
      this.isDisableSendMailButton = true;
    } else {
      this.isDisableSendMailButton = false;
    }
  }
  fetchSMETemplate(userId, event) {
    if (!this.emailSubject?.includes('#Client')) {
      this.emailSubject = this.emailSubject.replace('Client', '#Client');
    }
    if (!event.target.checked) {
      this.selectedSmeId = 0;
      this.selectedSmeName = '';
      //this.emailContent = this.defaultModifyTemplate;
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    this.selectedSmeId = userId;
    this.selectedSmeName = this.sendSmeList.find(x => x.userId === userId).displayName;
    // const modififedTemplate = this.modifiedSMETemplates.filter(x => x.smeId === userId);
    // if (modififedTemplate.length > 0) {
    //   this.emailContent = modififedTemplate[0].emailContent;
    // } else {
    //   this.emailContent = this.defaultTemplate;
    // }
    event.stopPropagation();
    event.preventDefault();
    return;
  }
  closeRightSideDrawer() {
    this.rightSideDrawerService.closeRightSideDrawer();
  }
  divEvent(event) {
    if (!this.emailSubject?.includes('#Client')) {
      this.emailSubject = this.emailSubject.replace('Client', '#Client');
    }
    event.stopPropagation();
    event.preventDefault();
  }
  toUnicode(text) {
    let hex;
    let i;
    let result = '';
    for (i = 0; i < text.length; i++) {
      hex = text.charCodeAt(i).toString(16);
      result += ('u00' + hex).slice(-7);
    }
    return result;
  }

  onCustomTemplateTitleSelected(selectedOption: CustomDropDown): void {
    if (!selectedOption) return;
    this.customTemplateTitle = selectedOption.value;
    if (selectedOption.id === 0) {
      this.showSaveButton = false;
      this.showDeleteButton = false;
      this.emailContent = this.removeKeywordsFromTemplate(this.defaultTemplate);
      this.isAutoReminderTemplate = this.isDefaultAutoReminderTemplate;
      return;
    }
    else {
      this.showSaveButton = true;
      this.showDeleteButton = true;
    }
    this.rightSideDrawerService.spinnerLoad(true);
    this.getCustomEmailTemplate(selectedOption.id);
  }

  private getCustomEmailTemplate(templateId: number) {
    this._emailService.GetCustomEmailTemplate(this.emailPopupData.engagementId, templateId)
      .subscribe((data: CustomTemplateRequest) => {
        if (data) {
          this.emailContent = this.removeKeywordsFromTemplate(decodeText(data.template));
          this.isAutoReminderTemplate = data.isAutoReminderTemplate;
          if (this.isAutoReminderTemplate) {
            this.isDefaultAutoReminderTemplate = false;
          }
          this.rightSideDrawerService.spinnerLoad(false);
        }
      });
  }

  ifDefaultTemplateAndAutoReminder() {
    return this.isAutoReminderTemplate && (this.customTemplateTitle === this.DEFAULT_EMAIL_TEMPLATE);
  }

  getSwitchState() {
    return this.isReminderEnabled && this.isAutoReminderTemplate;
  }

  isSwitchDisabled() {
    return this.ifDefaultTemplateAndAutoReminder() || !this.isReminderEnabled;
  }

  getSwitchStyle(): string {
    if (!this.isReminderEnabled) return 'switch-study-disabled';
    if (this.isSwitchDisabled()) return 'switch-disabled';
    return '';
  }

  getToggleTooltip() {
    return this.ifDefaultTemplateAndAutoReminder()
      ? 'Please select custom template as auto-reminder template'
      : '';
  }

  toggleAutoReminderTemplate(event: boolean) {
    this.isAutoReminderTemplate = event;
    this.isDefaultAutoReminderTemplate = this.customTemplateTitle === this.DEFAULT_EMAIL_TEMPLATE
      ? this.isAutoReminderTemplate
      : !this.isAutoReminderTemplate
    var useAsAuto = new UseAsAutoReminderEmailDto();
    useAsAuto.templateId = this.customTemplateTitleOptions.find(x => x.value === this.customTemplateTitle)?.id;
    useAsAuto.engagementId = this.emailPopupData.engagementId;;
    useAsAuto.isAuto = event;
    this._emailService.useAsAutoReminderEmail(useAsAuto)
      .subscribe((result: boolean) => {
        if (result) {
          this.toastrService.setSuccessMessage(event
            ? Messages.Survey.SetAsAutoReminderEmail
            : Messages.Survey.ResetAsAutoReminderEmail);
        }
      });
    this.resetTemplateOption(event, useAsAuto.templateId);
  }

  resetTemplateOption(event: boolean, templateId: number) {
    const options: CustomDropDown[] = [];
    this.customTemplateTitleOptions.forEach(element => {
      options.push({
        id: element.id,
        value: element.value,
        isDisabled: false,
        showToolTip: event && templateId === element.id
      });
    });
    this.customTemplateTitleOptions = this.setDefaultAutoReminderTemplate(options);
  }

  saveNewCustomTemplate() {
    this.showSaveTemplateOption = true;
    this.showSaveButton = false;
    this.showDeleteButton = false;
    this.showRefreshButton = false;
    this.targetForm.controls.templateName.setValue('');
  }

  cancelSaveCustomTemplate() {
    this.showSaveTemplateOption = false;
    this.showRefreshButton = true;
    if (this.customTemplateTitle !== this.DEFAULT_EMAIL_TEMPLATE) {
      this.showDeleteButton = true;
      this.showSaveButton = true;
    }
  }

  saveModifiedCustomTemplate() {
    const templateName = this.targetForm.get('templateName').value;
    let templateid = 0;
    if (this.showSaveTemplateOption) {
      if (templateName === '') {
        this.toastrService.setErrorMessage(Messages.Survey.TemplateName);
        return;
      }
      const duplicateTemplateName = this.customTemplateTitleOptions.filter(x => x.value === templateName);
      if (duplicateTemplateName.length > 0) {
        this.toastrService.setErrorMessage(Messages.Survey.DuplicateTemplateName);
        return;
      }
    } else {
      templateid = this.customTemplateTitleOptions.filter(x => x.value === this.customTemplateTitle)[0].id;
    }
    this.rightSideDrawerService.spinnerLoad(true);
    const sendRequest = new CustomTemplateRequest();
    sendRequest.id = templateid
    sendRequest.engagementId = this.emailPopupData.engagementId;
    sendRequest.name = encodeText(templateName);
    sendRequest.template = encodeText(this.emailContent);
    sendRequest.templateType = this.emailPopupData.requestTemplateType;
    sendRequest.surveyCategoryId = SurveyCategory.AllSurvey;
    this._emailService.saveCustomEmailTemplate(sendRequest).subscribe((data: CustomTemplateRequest) => {
      if (this.showSaveTemplateOption) {
        this.customTemplateTitleOptions.push({ id: data.id, value: data.name, isDisabled: false });
        this.customTemplateTitle = data.name;
        this.isAutoReminderTemplate = data.isAutoReminderTemplate;
        this.showDeleteButton = true;
      }
      this.showSaveTemplateOption = false;
      this.showSaveButton = true;
      this.showRefreshButton = true;
      this.toastrService.setSuccessMessage(Messages.Survey.SaveEmailTemplate);
      this.rightSideDrawerService.spinnerLoad(false);
    });
  }

  getCustomTemplateOptions(customEmailTemplatesList: CustomEmailTemplateDto[]) {
    const options: CustomDropDown[] = [{ id: 0, value: this.DEFAULT_EMAIL_TEMPLATE, isDisabled: false, showToolTip: false }];
    customEmailTemplatesList.forEach(element => {
      options.push({
        id: element.id,
        value: element.name,
        isDisabled: false,
        showToolTip: element.isAutoReminderTemplate
      });
    });
    return this.setDefaultAutoReminderTemplate(options);
  }

  setDefaultAutoReminderTemplate(options: CustomDropDown[]): CustomDropDown[] {
    if (options?.every(x => !x.showToolTip)) {
      var i = options.findIndex(x => x.value == this.DEFAULT_EMAIL_TEMPLATE);
      if (i > -1 && this.emailType !== EMAIL_TEMPLATE_TYPE.ASSIGNMENT_EMAIL) {
        options[i].showToolTip = true;
      }
    }
    return options;
  }

  deletionCustomTemplate() {
    this.rightSideDrawerService.spinnerLoad(true);
    const sendRequest = new CustomTemplateRequest();
    sendRequest.id = this.customTemplateTitleOptions.filter(x => x.value === this.customTemplateTitle)[0].id;
    sendRequest.engagementId = this.emailPopupData.engagementId;
    sendRequest.surveyCategoryId = SurveyCategory.AllSurvey;
    if (sendRequest.id > 0) {
      this._emailService.deleteCustomEmailTemplate(sendRequest).subscribe((data: CustomTemplateRequest) => {
        var template = this.customTemplateTitleOptions.filter(x => x.value === this.customTemplateTitle)[0];
        var indexNo = this.customTemplateTitleOptions.indexOf(template);
        if (indexNo > -1) {
          this.customTemplateTitleOptions.splice(indexNo, 1);
        }
        this.customTemplateTitle = this.DEFAULT_EMAIL_TEMPLATE;
        this.emailContent = this.removeKeywordsFromTemplate(this.defaultTemplate);
        this.showSaveButton = false;
        this.showDeleteButton = false;
        this.toastrService.setSuccessMessage(Messages.Survey.DeleteEmailTemplate);
        this.rightSideDrawerService.spinnerLoad(false);
      });
    }
  }

  removeKeywordsFromTemplate(template: string) {
    
    const keywordsToRemove = ['script', 'onerror', 'onload', 'onfocus', 'onblur', 'onchange', 'onsubmit', 
        'onkeyup', 'onkeypress', 'onkeydown', 'onmouseenter', 'onmouseleave', 'ondblclick', 'onloadstart', 'onloadend', 'onloaderror', 
        'onbeforeunload', 'onafterprint', 'onbeforeprint', 
        'onmouseover', 'onmouseout', 'onmousedown', 'onmouseup', 'onmousemove', 'oncontextmenu',
        'onselect', 'onselectionchange', 'oncopy', 'oncut', 'onpaste', 'ontouchstart',
        'javascript:', 'vbscript', 'eval\\(\\', 'eval \\(\\', 'alert', 'document.cookie', 'XSS',      
        'window.location', 'iframe', 
         'XMLHttpRequest', 'fetch', 'postMessage', 'localStorage', 'sessionStorage',
        'cookie', 'srcdoc', 'data:text/html', 'object', 'formaction', 'action=', 'prompt', 'confirm', 'window.open', 'window.close', 
        'window.location',
        'innerText', 'textContent', 'innerHTML', 'outerText', 'outerHTML', 'contentWindow',
        'innerHTML',
        'outerHTML', 'contenteditable', 'designMode', 'allow-scripts', 'allow-same-origin',];

    const regex = new RegExp(`\\b(${keywordsToRemove.join('|')})\\b`, 'gi');
    // prepended text for testing
    //template = '<img src="invalid.jpg" onerror="alert(\'XSS\')">' + template;
    template = template.replace(regex, '');

    return template;
  }

}
